import cn from 'classnames';
import * as React from 'react';

import * as styles from './asideSection.css';

export const AsideSection = (
  props: React.PropsWithChildren<{
    withShadow?: boolean;
    withBorders?: boolean;
    withSpaces?: boolean;
    hideForPrint?: boolean;
    dataName?: string;
  }>,
) => {
  const { dataName, withShadow = true, withBorders = true, withSpaces = true, hideForPrint = false } = props;

  return (
    <div
      data-name={dataName}
      className={cn(
        styles['section'],
        withShadow && styles['shadow'],
        withBorders && styles['borders'],
        withSpaces && styles['spaces'],
        hideForPrint && styles['hide-for-print'],
      )}
    >
      {props.children}
    </div>
  );
};
